import { Select } from '@iwoca/orion';
import { msg } from '@lingui/core/macro';
import { useLingui } from '@lingui/react/macro';
import { clsx } from 'clsx';
import { useFormContext } from 'react-hook-form';

import { TGetStartedDataDE } from './GetStartedDE';
import styles from './GetStartedDE.module.css';
import { useLocale } from '../../../hooks/useLocale';

export const LOAN_DURATION_OPTIONS = [
  {
    label: msg`Short term: just a few months`,
    value: 'few_months',
  },
  {
    label: msg`Medium term: 1-2 years`,
    value: 'one_to_two_years',
  },
  {
    label: msg`Long term: 3-5 years`,
    value: 'three_plus_years',
  },
  {
    label: msg`Flexible: access money as needed`,
    value: 'ongoing',
  },
] as const;

const LoanDuration = () => {
  const { i18n } = useLocale();
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TGetStartedDataDE>();

  return (
    <Select
      {...register('loanDuration')}
      label={t`How long do you need the loan for?`}
      placeholder={t`Please select`}
      className={clsx({
        [styles.erroredSelect]: errors.loanDuration?.message,
      })}
      error={errors.loanDuration?.message}
    >
      {LOAN_DURATION_OPTIONS.map((option) => (
        <option key={option.value} value={option.value}>
          {i18n._(option.label)}
        </option>
      ))}
    </Select>
  );
};

export default LoanDuration;
